module.exports = __webpack_public_path__ + "static/media/YM83_3.6272fcb4.jpg";